import React from "react";
import { withStyles } from "@material-ui/core";
import { KPI_GROUP_LABEL } from "../constants";

const styles = (theme) => ({
  kpiGroupContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginLeft: 8,
  },
  kpiGroupLabel: {
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
    lineHeight: "19px",
  },
  kpiGroupTag: {
    color: theme.iconColor,
    fontSize: theme.textFontSize,
    fontWeight: 400,
    lineHeight: "16px",
  },
});

const KPIGroupHeader = ({ classes, kpiGroup, suffix }) => {
  if (!KPI_GROUP_LABEL[kpiGroup]) {
    return <></>;
  }
  return (
    <div className={classes.kpiGroupContainer}>
      <span className={classes.kpiGroupLabel}>{kpiGroup}</span>
      <span className={classes.kpiGroupTag}>{suffix}</span>
    </div>
  );
};

export default withStyles(styles)(KPIGroupHeader);
